import { render, staticRenderFns } from "./AlertBadge.vue?vue&type=template&id=747e0f24"
import script from "./AlertBadge.vue?vue&type=script&lang=js"
export * from "./AlertBadge.vue?vue&type=script&lang=js"
import style0 from "./AlertBadge.vue?vue&type=style&index=0&id=747e0f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports